import http from '@/api/fetch.js'
import Vue from 'vue'
import Router from '@/router'
// 请求配置
import { needCatchList, usersInfo } from '@/api/config.js'
import { deepClone, localCatch, sessionCatch, getVariableType } from '@/utils'
let isShowModal = false;
export function requestBefore(name, query, modifyObj, type) {
	let that = Vue.prototype;
	let catchObj = deepClone(needCatchList[name] || {});
	if(modifyObj){
		for(var i in modifyObj){
			if(typeof modifyObj[i] == 'object' && typeof catchObj[i] == 'object'){
				Object.assign(catchObj[i], modifyObj[i])
			}else{
				catchObj[i] = modifyObj[i];
			}
		}
	}
	if(!catchObj.url){//请求地址不能为空
		return new Promise((resolve, reject) => {
			Vue.prototype.$toast('请求地址不能为空');
			console.error('[fatal error] 请求地址不能为空，『' + name + '』不存在请求表中');
			reject({code: -1, msg: '请求地址不能为空'});
		})
	}
	if(catchObj.catchName && !catchObj.update && catchObj.abort){//说明需要存缓存，先去去缓存，强制更新他人的  必须请求
		var storage = catchObj.persistence ? localCatch.get : sessionCatch.get;
		var catchName = getCatchName(catchObj.catchName, query)
		var catchStorage = storage(catchName);
		if(catchStorage) return new Promise((resolve, reject) => {
			resolve({code: 1,msg: '读取缓存成功',data: catchStorage});
		})
	}
	type = (type || catchObj.type || 'POST').toLocaleLowerCase();
	return new Promise((resolve, reject) => {
		catchObj.loading && that.$loading.close();
		catchObj.loading && that.$loading(catchObj.loading);
		let isAddUrl = catchObj.url.lastIndexOf('/') === catchObj.url.length - 1;
		catchObj.url += (isAddUrl ? query : '');
		http(catchObj.url, isAddUrl ? {} : query, type).then(async res => {
			catchObj.loading && that.$loading.close();
			if(res.code === 1){
				res.data = catchObj.catchBefore ? await catchObj.catchBefore(res.data) : res.data;
				if(catchObj.catchName || catchObj.update){//表示要进行缓存或者强制更新
					catchHandle(catchObj, res, query);
				}
				if(catchObj.removeName){
					var removeObj = needCatchList[catchObj.removeName];
					var removeName = getCatchName(removeObj.name);
					if(removeObj.persistence){
						uni.removeStorageSync(removeName)
					}else{
						sessionCatch.remove(removeName)
					}
				}
				catchObj.toast && that.$toast(catchObj.toast);
			}else if(res.code === 501){//未登录或者登录过期
				if(isShowModal) return ;
				isShowModal = true;
				that.$dialog.confirm('您还没有登录，请登录后操作', {
					okText: '去登录',
					cancelText: catchObj.modalBack ? '返回' : '我再想想'
				})
				.then(function() {
					isShowModal = false;
					// 点击确定执行
					Router.push({
						name: 'login'
					})
				})
				.catch(function() {
					isShowModal = false;
					// 点击取消执行
					catchObj.modalBack && Router.back();
				});
			}else if(res.code === 500){
				that.$toast(res.msg);
			}else{
				catchObj.toast && that.$toast(res.msg);
			}
			resolve(res);
		}).catch(err => {
			catchObj.loading && that.$loading.close();
			reject(err);
		})
	})
}
/**
 * @description 缓存统一设置或删除管理
 * @param {Object} catchObj 缓存对象
 * @param {type} queryObj 请求参数
 */

function catchHandle(catchObj = {}, resObj = {}, queryObj = {}) {
	let catchName = getCatchName(catchObj.catchName, queryObj);
	catchObj.catchName && setStorageSync(catchName, catchObj, resObj.data);
}

/**
 * @description 获取缓存名称
 * @param {Object} catchObj 缓存项
 * @return {String}
 */
const getCatchName = (nameObj, queryObj = {}) => {
	let catchName = '';
	if (typeof nameObj === 'object') {
		catchName = nameObj.value;
		if (nameObj.position) {
			let _key = nameObj.key || '';
			let extraName = _key && queryObj && queryObj.hasOwnProperty(_key) ? queryObj[_key] : _key;
			let nameStorage;
			if (typeof nameObj.storage === 'function') {
				(async () => {
					nameObj.storage = await nameObj.storage();
				})();
			}
			nameStorage = nameObj.storage ? nameObj.storage : false;
			if (nameStorage) {
				extraName = nameStorage[extraName] || '';
			}
			catchName = nameObj.position === 'after' ? (catchName + extraName) : (extraName + catchName);
		}
	} else {
		catchName = nameObj;
	}
	return catchName;
}
// 设置缓存
function setStorageSync(name, catchObj, data) {
	if (getVariableType(data) === 'Object' && JSON.stringify(data) === '{}') return;
	if (getVariableType(data) === 'Array' && data.length === 0) return;
	let {
		persistence
	} = catchObj;
	if (persistence) {
		localCatch.set(name, data);
	} else {
		sessionCatch.set(name, data);
	}
}